module.exports = __webpack_public_path__ + "static/forecast/forecast-sunrise-9058dda9568a6eb04fccd2e874ac9a29.svg";